<template>
    <img :src="layer.src"
         :class="[availableLayer ? 'availableLayer' : 'imageLayer' ]"
         :id="'layer-' + id"
         :ref="'layer-' + id"
         @click="availableLayer ? $emit('addLayer') : $emit('toggleLock')">
</template>

<script type="text/babel">
export default {
    name: 'image',
    props: {
        availableLayer: {
            type: Boolean,
            default: false
        },
        id: {
            type: String
        },
        layer: {
            type: Object
        }
    }
};

</script>
